import { COMMON_PAGE_LIMIT, prepareIdsForChunking } from '@wix/a11y-wizard-common';
import { queryExperiences } from '@wix/ambassador-table-reservations-v1-experience/http';
export const fetchTableReservationsExperiences = async (httpClient, errorHandler, ids) => {
  const {
    withErrorHandler
  } = errorHandler;
  const allExperiences = [];
  await withErrorHandler(async () => {
    const idChunks = prepareIdsForChunking(ids, COMMON_PAGE_LIMIT);
    const chunkPromises = idChunks.map(async idChunk => {
      const chunkExperiences = [];
      let hasMore = true;
      let cursor;
      do {
        var _pagingMetadata$curso;
        const response = await httpClient.request(queryExperiences({
          query: {
            cursorPaging: {
              cursor,
              limit: COMMON_PAGE_LIMIT
            },
            filter: idChunk.length > 0 ? {
              id: {
                $in: idChunk
              }
            } : undefined
          }
        }));
        const {
          experiences,
          pagingMetadata
        } = response.data;
        chunkExperiences.push(...(experiences ?? []));
        hasMore = (pagingMetadata == null ? void 0 : pagingMetadata.hasNext) ?? false;
        cursor = pagingMetadata == null || (_pagingMetadata$curso = pagingMetadata.cursors) == null ? void 0 : _pagingMetadata$curso.next;
      } while (hasMore);
      return chunkExperiences;
    });
    const results = await Promise.all(chunkPromises);
    allExperiences.push(...results.flat());
  }, {
    errorCodesMap: {}
  });
  return allExperiences;
};
//# sourceMappingURL=fetch-table-reservations-experiences.js.map